(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/utils/assets/javascripts/format.js') >= 0) return;  svs.modules.push('/components/accountservices/utils/assets/javascripts/format.js');

'use strict';

var _svs;
svs = svs || {};
svs.accountservices = svs.accountservices || {};
svs.accountservices.utils = svs.accountservices.utils || {};
let log;
if ((_svs = svs) !== null && _svs !== void 0 && (_svs = _svs.core) !== null && _svs !== void 0 && _svs.log) {
  log = new svs.core.log.Logger('components:accountservices:utils:format');
}
class Format {
  static phoneNumber() {
    let phoneNumberToFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    if (!phoneNumberToFormat || typeof phoneNumberToFormat !== 'string' || phoneNumberToFormat.length < 10) {
      return '';
    }
    let phoneNumber = phoneNumberToFormat.replace(/-| /g, '');
    let separateAt = 4;
    const insertCharAt = function () {
      let string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      let at = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      let char = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ' ';
      return "".concat(string.slice(0, at)).concat(char).concat(string.slice(at));
    };
    if (phoneNumber.startsWith('+46')) {
      separateAt = 6;
    } else if (phoneNumber.startsWith('0046')) {
      separateAt = 7;
    }
    let i = phoneNumber.length - 2;
    while (i > separateAt) {
      phoneNumber = insertCharAt(phoneNumber, i);
      i = i - 2;
    }
    phoneNumber = insertCharAt(phoneNumber, separateAt, ' - ');
    return phoneNumber;
  }
  static formatJsonFromJupiterErrorMsg(msg) {
    try {
      const decoded = decodeURIComponent(msg);
      const jsonString = decoded.substring(0, decoded.indexOf('}') + 1);
      const asJson = JSON.parse(jsonString);
      return asJson;
    } catch (e) {
      log && log.debug('Error parsing error message from Jupiter', e);
      return null;
    }
  }
}
svs.accountservices.utils.Format = Format;
if (typeof exports === 'object') {
  module.exports = {
    Format
  };
}

 })(window);